import { PageHeader } from '../Common'
import PracticeSelectView from '../Practices/PracticeSelectView'
import { toPath } from '../../routes'

export default function PreAuthorizations() {
  return (
    <div>
      <PageHeader title="Remote Authorizations" />
      <PracticeSelectView routeMethod={toPath.practices.preAuthorizations} />
    </div>
  )
}
